// 判断是否移动端
export function isMobile() {
  const reg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
    const isMobileUA = reg.test(navigator.userAgent);
     // 视口宽度小于等于1080px 也视为移动端
  const smallScreen = window.innerWidth <= 750;
  console.log(window.innerWidth);
 // 满足任意一个 = 移动端；大于1080px 就是PC
  return isMobileUA || smallScreen;
  // return isMobileUA ;
}